export const messagesLogin = {
  pt: {
    message: {
      email: "E-MAIL",
      enterEmail:
        "Informe seu e-mail cadastrado e lhe enviaremos um link de redefinição de senha.",
      password: "SENHA",
      redefinePassword: "Redefinir Senha",
      access: "Acessar",
      forgotPassword: "Esqueci minha senha",
      metaDescription:
        "Tela de login de acesso ao software de hotspot Wi-Fi do WiFeed para que os clientes e usuários possam acessar a plataforma.",
    },
  },
  es: {
    message: {
      email: "EMAIL",
      enterEmail:
        "Ingrese su correo electrónico registrado y le enviaremos un enlace de redefinición de contraseña",
      password: "CONTRASEÑA",
      redefinePassword: "Redefinir contraseña",
      access: "Acceso",
      forgotPassword: "Olvide mi contraseña",
      metaDescription:
        "Pantalla de inicio de sesión de acceso al software de punto de acceso Wi-Fi WiFieed para que los clientes y usuarios puedan acceder a la plataforma.",
    },
  },
  en: {
    message: {
      email: "EMAIL",
      enterEmail:
        "Enter your registered email and we will send you a password reset link.",
      password: "PASSWORD",
      redefinePassword: "Redefine password",
      access: "Access",
      forgotPassword: "Forgot my password",
      metaDescription:
        "WiFeed Wi-Fi hotspot software access login screen so customers and users can access the platform.",
    },
  },
};
